import React from "react";

// Components ///
import Button from "../../atoms/button/button";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// Styles //
import "./connect-to.scss";
import TitleSection from "../../molecules/title-section";

const ConnectTo = (props: ReferenciaContenido) => {
    const { tituloBoton, redireccionBoton, descripcion } = props;
    const url = new URL(window.location.href);

    return (
        <div
            className={`o-connect-to-job ${
                props.contentful_id === "6IkoAfhnMSP31Dsi2yGrdY"
                    ? "o-verificationMpc"
                    : props.contentful_id === "4u8cWQsqarcoJBMqKk9PqB"
                    ? "o-recoverSubsidy"
                    : ""
            }`}
        >
            <div className={`container`}>
                <div className="o-connect-to-job__container">
                    {(props.contentful_id === "6IkoAfhnMSP31Dsi2yGrdY" || "4u8cWQsqarcoJBMqKk9PqB") && (
                        <TitleSection title={props.tituloGeneral}/>
                    )}
                    {props.descripcion &&
                        <p className="o-connect-to-job__paragraph">
                            {
                                documentToReactComponents(
                                    descripcion.json.content[0].content[0]
                                )
                            }
                        </p>
                    }
                    <Button
                        type="link"
                        text={tituloBoton}
                        classname={
                            url.pathname === "/empresas/"
                                ? `a-button__green`
                                : `a-button__magenta gtmPersonasClicButtonConoceVacantes`
                        }
                        href={redireccionBoton}
                        isDisabled={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConnectTo;
